<template>
  <div class="social-deliverable-campaigns" v-if="deliverable && !disabled">
    <template v-if="!disabled">
      <div class="pb-0 exclude-outside-click" v-if="!addCampaignFlag">
        <div class="department-label">Campaign</div>
        <div
          class="department-title exclude-outside-click"
          :class="canEditSocialCampaign(selectedCampaign) ? '' : 'pointer-default'"
          :key="'deliverable-modal-department-'+deliverable.social_campaigns[0]"
          v-if="deliverable.social_campaigns.length"
          @click="clickTitle"
        >
          {{ campaignTitle }}
        </div>
        <div @click="showAddSocialCampaign()" class="department-title exclude-outside-click" v-if="!deliverable.social_campaigns.length">None</div>
        <button @click="showAddSocialCampaign()" v-if="canEditSocialCampaign(selectedCampaign)" type="button" class="plus-button plus-button--small exclude-outside-click">
          <img class="exclude-outside-click" src="@/csmworkflow/img/pencil.svg" />
        </button>
      </div>
      <div v-if="addCampaignFlag"  class="department-label">Assign to a different campaign</div>
      <multiselect
        ref="socialCampaigns"
        v-click-outside="outside"
        v-if="addCampaignFlag"
        v-model="selectedCampaign"
        :close-on-select="true"
        :options="campaignsOption"
        :show-labels="false"
        :multiple="false"
        :taggable="true"
        label="name"
        track-by="id"
        :id="deliverable.deliverableId"
        @tag="createCampaign"
        @input="socialCampaignSelected()"
        @close="addCampaignFlag=false"
      ></multiselect>
    </template>
    <template v-else>
      <div class="pb-0 titles exclude-outside-click">
        <div
          class="department-title exclude-outside-click"
          :key="'deliverable-modal-department-'+deliverable.social_campaigns[0]"
          v-if="deliverable.social_campaigns.length"
        >
          {{ deliverable.social_campaigns[0] }}
        </div>
        <div class="department-title exclude-outside-click" v-if="!deliverable.social_campaigns.length">No Campaign</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: ["deliverable","disabled", "showingDetails"],
  data() {
    return {
      addCampaignFlag: false,
      selectedCampaign: null,
    };
  },
  computed: {
    console: () => console,
    ...mapGetters(["allSocialCampaigns", "userAbilities", "allUserManageSocialCampaigns", ]),
    campaignsOption() {
      let campaignArr = [];
      if (this.userAbilities.accessAllSocialCampaigns) {
        if(this.allSocialCampaigns) {
        	return this.allSocialCampaigns;
        }
      } else {
        if(this.allUserManageSocialCampaigns) {
        	return this.allUserManageSocialCampaigns;
        }
      }
      return campaignArr;
    },
    hasCampaignOption() {
      if(this.campaignsOption){
        if(this.campaignsOption.length){
          return true;
        }
      }
      return false;
    },
    deliverableCampaign(){
      if(this.deliverable.social_campaigns.length && this.allSocialCampaigns.length){
        let campaign_id = this.deliverable.social_campaigns[0];
        return this.allSocialCampaigns.filter(campaign => campaign.id === campaign_id)[0];
      }
      return null;
    },
    campaignTitle(){
      if(this.selectedCampaign){
        return this.selectedCampaign.name;
      } else {
        return "None";
      }
    }
  },
  methods: {
    ...mapActions(["setDeliverableSocialCampaign", "fetchSocialCampaign", "fetchSocialCampaigns", "fetchSocialMediaDeliverablesGrouped"]),
    ...mapMutations(["setDataLoading"]),
    showAddSocialCampaign() {
     if (this.userAbilities.accessAllSocialCampaigns) {
      this.fetchSocialCampaigns()
     }

      if(!this.canEditSocialCampaign(this.selectedCampaign)) return;
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.addCampaignFlag = true
      this.$nextTick(() => {
        this.$refs.socialCampaigns.$el.focus()
      })
    },
    clickTitle() {
      this.$emit("click-title");
    },
    outside() {
      this.$set(this, "addCampaignFlag", false);
    },
    userCanEditCampaign(campaign) {
      if (!campaign) return false;

      const userId = localStorage.getItem("userId");

			if (this.userAbilities.accessAllSocialCampaigns) {
				return this.userAbilities.editSocialCampaign;
			}

			let isManager = false;
			if (campaign.engagement_manager instanceof Object) {
				isManager = userId == campaign.engagement_manager.id;
			} else {
				isManager = userId == campaign.engagement_manager;
			}

			return (this.userAbilities.editSocialCampaign && isManager);
    },
    canEditSocialCampaign(campaign) {
      if (this.userAbilities.accessAllSocialCampaigns) return true;

      const userId = localStorage.getItem("userId");
      let isManager = false;
      if (campaign) {
        if (campaign.engagement_manager instanceof Object && campaign.project_lead instanceof Object) {
          isManager = userId == campaign.engagement_manager.id || userId == campaign.project_lead.id;
        } else {
          isManager = userId == campaign.engagement_manager || userId == campaign.project_lead;
        }
      } else {
        isManager = true;
      }

      return (this.userAbilities.editMediaCall && isManager);
    },
    setSelectedCampaign(campaign){
      if(campaign){
        this.selectedCampaign = {
          id: campaign.id, 
          name: campaign.name, 
          engagement_manager: campaign.engagement_manager, 
          project_lead: campaign.project_lead
        }
      } else {
        this.selectedCampaign = null;
      }
      
    },
    socialCampaignSelected(){
      let that = this;
      if(this.selectedCampaign){
        this.setDeliverableSocialCampaign({
          id: this.deliverable.id,
          social_campaign_id: this.selectedCampaign.id
        });
      } else {
        this.setDeliverableSocialCampaign({
          id: this.deliverable.id,
          social_campaign_id: null
        });
      }
    },
    createCampaign(campaignTitle) {
      let that = this;
      this.$store.dispatch("createSocialCampaignForDeliverable", { 
        title: campaignTitle,
        id: that.deliverable.id
      });
    },
  },
  watch: {
    allSocialCampaigns(){
      this.setSelectedCampaign(this.deliverableCampaign);
    },
    allUserManageSocialCampaigns(){
      this.setSelectedCampaign(this.deliverableCampaign);
    }

  },
  created(){
    this.setSelectedCampaign(this.deliverableCampaign);
  },
  mounted(){
    this.setSelectedCampaign(this.deliverableCampaign);
  },

};
</script>

<style scoped>
.department-title {
	font-size: 22px;
font-weight: 500;
line-height: 1;
color:unset;
text-transform:unset;

}

.social-deliverable-campaigns {
	width:100%;
}
.department-label {
/*color:unset;*/
color: #4C9850;
display:block;
font-weight: 400;
font-size: 1em;
	}

	.plus-button {
		position: relative;
	top: -4px;
	right: -10px;

	}

</style>
